




















































































import Vue, { PropType } from "vue";
import { GroupsQuery_groups } from "@/graphql/generatedTypes/GroupsQuery";
import GroupDateTime from "@/components/GroupDateTime.vue";
import formatUtils from "@/components/FormatUtil";
import moment from "moment";

export default Vue.extend({
  name: "GroupList",
  components: { GroupDateTime },
  props: {
    groups: Array as PropType<GroupsQuery_groups[]>
  },
  methods: {
    ...formatUtils,
    shouldDisableDetailsLink(group: { isFull: boolean }) {
      if (this.$route.params?.userId) {
        return false;
      }

      return group.isFull;
    },
    viewingUserGroups() {
      return this.$route.params?.userId;
    },
    groupInProgress(group: GroupsQuery_groups): boolean {
      return group.sessions.some(
        session =>
          moment().isAfter(`${session.date} ${formatUtils.timeOnly(session.time ? session.time : "")}`) &&
          session.status === "active"
      );
    },
    trainerName(group: GroupsQuery_groups): string {
      return !group?.trainer ? "" : `${group.trainer.firstName} ${group.trainer.lastName}`;
    },
    trainerEmail(group: GroupsQuery_groups): string {
      return !group?.trainer ? "" : group.trainer.email;
    }
  }
});
